export function DrawBSpacer(ctx, sx, sy, ex, ey, r) {
  ctx.setLineDash([0, 0]);
  ctx.strokeStyle = "#CC9999";
  //ctx.setLineDash([2, 2]);
  ctx.globalAlpha = 1.0;
  ctx.beginPath();
  ctx.moveTo(sx, sy);
  ctx.lineTo(ex, ey);
  ctx.stroke();

  ctx.fillStyle = "#000000";
  ctx.fillRect(sx - 1.5, sy - 1.5, 3, 3);
}
